import React from 'react'
import { Link } from 'react-router-dom'

const Contact = () => {
    return (
        <>
            <section>
                <div className="inner-banner-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="inner-banner-heading  wow fadeInLeft" data-wow-duration="2s">
                                    <h2>Contact Us</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="inner-contact-us-sec">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="inner-contact-us-box wow fadeInLeft" data-wow-duration="2s">
                                    <img src="images/inner-contact-us-icon-1.png" alt="img" />
                                    <h2>Phone Number</h2>
                                    <Link to="tel:1234567890">123 456 7890</Link>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="inner-contact-us-box wow fadeInDown" data-wow-duration="2s">
                                    <img src="images/inner-contact-us-icon-2.png" alt="img" />
                                    <h2>Email</h2>
                                    <Link to="mailto:info@domain.com">info@domain.com</Link>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12">
                                <div className="inner-contact-us-box wow fadeInRight" data-wow-duration="2s">
                                    <img src="images/inner-contact-us-icon-3.png" alt="img" />
                                    <h2>Address</h2>
                                    <Link to="">123 456 Street lorem iopsum<br />dummy text Here</Link>
                                </div>
                            </div>
                        </div>
                        <div className="inner-contact-us-row">
                            <div className="row">
                                <div className="col-lg-7 col-md-7 col-12">
                                    <div className="inner-contact-us-from wow fadeInLeft" data-wow-duration="2s">
                                        <h2>Contact us</h2>
                                        <form>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-12">
                                                    <input type="text" name="Name" placeholder="Name" />
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-12">
                                                    <input type="text" name="Phone" placeholder="Phone" />
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-12">
                                                    <input type="text" name="Email" placeholder="Email" />
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-12">
                                                    <input type="text" name="How Can Help You?" placeholder="How Can Help You?" />
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-12">
                                                    <textarea placeholder="Message" defaultValue={""} />
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-12">
                                                    <button type="submit" className="theme-btn-1">Submit NOw</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-12">
                                    <div className="inner-contact-us-images wow fadeInRight" data-wow-duration="2s">
                                        <img src="images/inner-contact-us-1.png" alt="img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact